module.exports = __webpack_public_path__ + "img/popup_win.959b7573.png";